const Username = process.env.REACT_APP_USERNAME;
const Password = process.env.REACT_APP_PASSWORD;

const getBaseUrl = () => {
  switch (process.env.REACT_APP_ENV) {
    case "production":
      return "https://gzd1kcywwk.execute-api.us-east-1.amazonaws.com";
    case "staging":
      return "https://ds5p34fp5g.execute-api.us-east-1.amazonaws.com";
    default:
      // return "https://ds5p34fp5g.execute-api.us-east-1.amazonaws.com";
      return "http://localhost:5002";
  }
};

const getBaseUrlA = () => {
  switch (process.env.REACT_APP_ENV) {
    case "production":
      return "https://98upd0g6v9.execute-api.us-east-1.amazonaws.com/Prod/ciqlertesting";
    case "staging":
      return "https://98upd0g6v9.execute-api.us-east-1.amazonaws.com/Prod/ciqlertesting";
    default:
      // return 'http://127.0.0.1:3000/ciqlertesting';
      return "https://98upd0g6v9.execute-api.us-east-1.amazonaws.com/Prod/ciqlertesting";
  }
};

module.exports = {
  BASE_URL: getBaseUrl(),
  BASE_URL_A: getBaseUrlA(),
  Username,
  Password,
};
